import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Paper from '@base/Paper/Paper';
import H2 from '@base/H2/H2';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import breadcrumbs, { goBack } from '@utils/breadcrumbs';
import { breakpoints, Spacings } from '@styles/index';
import { useSelector } from 'react-redux';
import { getPlusSubscriptionInfoLatest } from '@selectors/subscription';
import { getIsGTPGoal } from '@api/selectors/constants';
import pushRoute from '@utils/pushRoute';
import useConstants from '@api/hooks/useConstants';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsSubscribedToOffline } from '@api/selectors/subscription';

const StyledPaper = styled(Paper)`
  margin-bottom: ${({ isDropdown }) => isDropdown && Spacings.SPACING_6B};
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B} ${Spacings.SPACING_6B}
    ${Spacings.SPACING_12B};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    background: transparent;
    padding: 24px 0 0;
    box-shadow: none;
    grid-column: span 11;
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;

const ArrowCrumbsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyH2 = styled(H2)`
  margin-top: ${Spacings.SPACING_6B};
  color: var(--color-text-primary);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 22px;
  }
`;

const TopBlock = ({ label, goal, seeAllType, isDropdown, pageType }) => {
  const hasSubscription = useSelector(getPlusSubscriptionInfoLatest(goal.uid));
  const isGTP = useConstants(getIsGTPGoal(goal.uid));
  const isOfflineSubscription = useMyInfo(getIsSubscribedToOffline(goal?.uid));

  const handleGoBack = () => {
    if (isGTP) {
      return pushRoute(
        '/goal/[goalSlug]/[goalUID]/browse',
        `/goal/${goal.slug}/${goal.uid}/browse`
      );
    }
    goBack();
  };
  return (
    <StyledPaper gridColumn="span 18" isDropdown={isDropdown}>
      <ArrowCrumbsWrapper>
        <BreadCrumbs
          onBackClick={handleGoBack}
          useBackClick={isGTP}
          tags={breadcrumbs.getSeeAllTags(
            seeAllType,
            goal,
            null,
            hasSubscription,
            pageType,
            isGTP,
            isOfflineSubscription
          )}
        />
      </ArrowCrumbsWrapper>
      <StyH2 as="h1">{label}</StyH2>
    </StyledPaper>
  );
};

export default TopBlock;

TopBlock.propTypes = {
  goal: PropTypes.objectOf(PropTypes.any).isRequired,
  seeAllType: PropTypes.string.isRequired,
  label: PropTypes.string,
  isDropdown: PropTypes.bool
};

TopBlock.defaultProps = {
  label: '',
  isDropdown: false
};
